var exports = {
  "kL": "xa15a2ab7--0fe33c--container",
  "kb": "xa15a2ab7--0fe33c--left",
  "DD": "xa15a2ab7--0fe33c--title",
  "M1": "xa15a2ab7--0fe33c--stats",
  "AS": "xa15a2ab7--0fe33c--item",
  "Uo": "xa15a2ab7--0fe33c--buttons",
  "x6": "xa15a2ab7--0fe33c--button",
  "wm": "xa15a2ab7--0fe33c--logo",
  "D9": "xa15a2ab7--0fe33c--phones-opened-info",
};

module.exports = exports;
